import { useEffect, useRef, useState } from 'react';
import './vault-entry.css';

export const VAULT_ENTRY_DURATION = 5200;
const stages = ['Reconociendo tu llave…', 'Retirando los cerrojos…', 'Tu tesoro está a salvo.', 'Bienvenido a tu bóveda.'];

function DoorFace() {
  return <svg viewBox="0 0 500 500" className="vault-door-art" aria-hidden="true">
    <defs>
      <radialGradient id="vault-bronze" cx="35%" cy="25%"><stop stopColor="#cfb67d"/><stop offset=".35" stopColor="#85724d"/><stop offset=".72" stopColor="#4a3c2e"/><stop offset="1" stopColor="#211a19"/></radialGradient>
      <linearGradient id="vault-gold" x2="1" y2="1"><stop stopColor="#f7deb0"/><stop offset=".3" stopColor="#937042"/><stop offset=".55" stopColor="#e8ca8d"/><stop offset="1" stopColor="#50341e"/></linearGradient>
      <radialGradient id="vault-steel"><stop stopColor="#796a53"/><stop offset="1" stopColor="#2a2422"/></radialGradient>
      <pattern id="vault-grain" width="5" height="5" patternUnits="userSpaceOnUse"><path d="M0 1H5M0 4H5" stroke="#eed5a3" strokeOpacity=".045" strokeWidth=".5"/></pattern>
    </defs>
    <circle cx="250" cy="250" r="242" fill="url(#vault-bronze)" stroke="url(#vault-gold)" strokeWidth="6"/>
    <circle cx="250" cy="250" r="235" fill="url(#vault-grain)"/>
    {[228,211,192,178].map((r,i)=><circle key={r} fill="none" cx="250" cy="250" r={r} stroke={i%2?'#e7c68866':'#160f0daa'} strokeWidth={i===1?8:2}/>)}
    {Array.from({length:24},(_,i)=><g key={i} transform={`rotate(${i*15} 250 250)`}><circle cx="250" cy="29" r="4" fill="url(#vault-gold)"/><path d="M247 29h6" stroke="#3a2b20"/><path d="M250 44V53" stroke="#edcb8966"/></g>)}
    {Array.from({length:8},(_,i)=><g key={i} transform={`rotate(${i*45} 250 250)`}><path d="M234 80L250 62 266 80 250 95Z" stroke="#c6a76a" strokeWidth="1"/><path d="M250 70v18m-7-9h14" stroke="#e6c78788"/></g>)}
    <g className="vault-gears">
      {Array.from({length:12},(_,i)=><g key={i} transform={`rotate(${i*30} 250 250)`}><path d="M243 111h14v28h-14Z" fill="url(#vault-gold)"/><path d="M247 141V174" stroke="#ad8b54" strokeWidth="3"/></g>)}
      <circle cx="250" cy="250" r="118" fill="none" stroke="url(#vault-gold)" strokeWidth="12" strokeDasharray="8 5"/>
    </g>
    <circle cx="250" cy="250" r="104" fill="url(#vault-steel)" stroke="#d5b474" strokeWidth="3"/>
    <g className="vault-handle">
      <circle cx="250" cy="250" r="78" fill="none" stroke="#130e0d" strokeWidth="17"/>
      <circle cx="250" cy="250" r="78" fill="none" stroke="url(#vault-gold)" strokeWidth="10"/>
      {[0,60,120].map(a=><path key={a} transform={`rotate(${a} 250 250)`} d="M177 250H323" stroke="url(#vault-gold)" strokeWidth="9"/>)}
      <circle cx="250" cy="250" r="33" fill="url(#vault-bronze)" stroke="#d6b87a" strokeWidth="3"/>
      <text x="250" y="257" textAnchor="middle" fill="#f5dfb1" fontSize="21" fontFamily="Georgia,serif">CHP</text>
    </g>
    <g className="vault-door-nameplate">
      <rect x="133" y="391" width="234" height="34" rx="6" fill="#211a16" stroke="url(#vault-gold)" strokeWidth="1.5"/>
      <circle cx="142" cy="408" r="2" fill="#c8a66c"/>
      <circle cx="358" cy="408" r="2" fill="#c8a66c"/>
      <text x="250" y="413" textAnchor="middle" fill="#ffe5ac" fontSize="14" letterSpacing="2" fontFamily="Georgia,serif">ESCARBANCOCHP</text>
    </g>
  </svg>;
}

export default function VaultDoor({ onSkip }) {
  const skipRef = useRef(null);
  const [stage,setStage]=useState(0);
  useEffect(() => {
    skipRef.current?.focus();
    const timers=[1100,2400,4000].map((delay,index)=>setTimeout(()=>setStage(index+1),delay));
    return ()=>timers.forEach(clearTimeout);
  }, []);
  return <div className="vault-cinematic" role="dialog" aria-modal="true" aria-label="Entrando a tu bóveda">
    <div className="vault-cinema-grain" aria-hidden="true"/>
    <div className="vault-cinema-heading"><span>ESCARBANCOCHP</span><small>DONDE CADA TESORO TIENE SU LUGAR</small></div>
    <div className="vault-cinema-scene" aria-hidden="true">
      <div className="vault-stone-wall"/>
      <div className="vault-sconce sconce-left"/><div className="vault-sconce sconce-right"/>
      <div className="vault-portal">
        <div className="vault-inner-chamber"><div className="vault-inner-halo"/><div className="vault-inner-arch"/>
          <div className="vault-shelves shelves-left"/><div className="vault-shelves shelves-right"/>
          <div className="vault-treasure"><span>✧</span><b>CHP</b><small>TU HISTORIA, A SALVO.</small></div>
          {Array.from({length:12},(_,i)=><i key={i} className="vault-mote" style={{'--mote':i}}/>)}
        </div>
        <div className="vault-door-panel"><DoorFace/><div className="vault-door-rim"/></div>
        {Array.from({length:6},(_,i)=><div className="vault-bolt-axis" key={i} style={{transform:`rotate(${i*60}deg)`}}><div className="vault-bolt"/></div>)}
        <div className="vault-portal-rim"/>
      </div>
      <div className="vault-floor-light"/>
    </div>
    <div className="vault-cinema-caption"><span className="vault-entry-step">TU BÓVEDA PERSONAL · 0{stage+1} / 04</span><p role="status">{stages[stage]}</p><div className="vault-entry-progress" aria-hidden="true"><i/></div><button ref={skipRef} onClick={onSkip}>Omitir entrada →</button></div>
  </div>;
}
